import script from "./AdminTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=24c27847&scoped=true&lang=css"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c27847"]])

export default __exports__